import AppError from '@/services/error.service';

/**
 * Guarda los datos de varias instalaciones en el Store
 *
 * @param {Object} installations - Datos de las instalaciones
 */
const saveInstallations = ({ commit }, installations) => {
  try {
    commit('ADD_INSTALLATIONS', installations);
  } catch (error) {
    throw new AppError('saveInstallations');
  }
};

/**
 * Guarda los datos de una nueva instalación en el Store
 *
 * @param {Installation} installation - Datos de la instalación
 */
const saveInstallation = ({ commit }, { installationID, data }) => {
  try {
    commit('ADD_INSTALLATION', { installationID, data });
  } catch (error) {
    throw new AppError('saveInstallation');
  }
};

/**
 * Actualiza los datos de una instalación en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {Object} data - Datos de la instalación
 */
const updateInstallation = ({ commit }, { installationID, data }) => {
  commit('UPDATE_INSTALLATION', { installationID, data });
};

/**
 * Actualiza los datos de una instalación en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {Object} data - Datos de la instalación
 */
const deleteInstallation = ({ commit }, installationID) => {
  commit('DELETE_INSTALLATION', installationID);
};

/**
 * Añado un dispositivo a una instalación en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {String} deviceMac - Mac del dispositivo
 * @param {Object} data - Datos del dispositivo
 */
const saveDevice = ({ commit }, { installationID, deviceMac, data }) => {
  commit('ADD_DEVICE', { installationID, deviceMac, data });
};

/**
 * Actualiza los datos de un dispositivo en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {String} deviceMac - Mac del dispositivo
 * @param {Object} data - Datos del dispositivo
 */
const updateDevice = ({ commit }, { installationID, deviceMac, data }) => {
  commit('UPDATE_DEVICE', { installationID, deviceMac, data });
};

/**
 * Elimina un dispositivo de una instalación en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {String} deviceMac - Mac del dispositivo
 */
const deleteDevice = ({ commit }, { installationID, deviceMac }) => {
  commit('DELETE_DEVICE', { installationID, deviceMac });
};

/**
 * Añado una programación a una instalación en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {String} scheduleID - Id de la programación
 * @param {Object} data - Datos de la programación
 */
const saveSchedule = ({ commit }, { installationID, scheduleID, data }) => {
  commit('ADD_SCHEDULE', { installationID, scheduleID, data });
};

/**
 * Edita una programación de una instalación en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {String} scheduleID - Id de la programación
 * @param {Object} data - Datos de la programación
 */
const updateSchedule = ({ commit }, { installationID, scheduleID, data }) => {
  commit('UPDATE_SCHEDULE', { installationID, scheduleID, data });
};

/**
 * Elimina una programación de una instalación en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {String} scheduleID - Id de la programación
 */
const deleteSchedule = ({ commit }, { installationID, scheduleID }) => {
  commit('DELETE_SCHEDULE', { installationID, scheduleID });
};

/**
 * Añado una escena a una instalación en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {String} sceneID - Id de la escena
 * @param {Object} data - Datos de la escena
 */
const saveScene = ({ commit }, { installationID, sceneID, data }) => {
  commit('ADD_SCENE', { installationID, sceneID, data });
};

/**
 * Edita una escena de una instalación en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {String} sceneID - Id de la escena
 * @param {Object} data - Datos de la escena
 */
const updateScene = ({ commit }, { installationID, sceneID, data }) => {
  commit('UPDATE_SCENE', { installationID, sceneID, data });
};

/**
 * Elimina una escena de una instalación en el Store
 *
 * @param {String} installationID - Id de la instalación
 * @param {String} sceneID - Id de la escena
 */
const deleteScene = ({ commit }, { installationID, sceneID }) => {
  commit('DELETE_SCENE', { installationID, sceneID });
};

/**
 * Actualiza el orden de las escenas
 */
const updateScenesOrder = ({ commit }, { installationID, listScenes }) => {
  commit('UPDATE_LIST_SCENES', { installationID, listScenes });
};

/**
 * Guarda el clima de una instalación en el Store
 *
 * @param {String} installationID - ID de la instalación
 * @param {Object} data - Datos del clima
 */
const saveWeather = ({ commit }, { installationID, data }) => {
  commit('ADD_WEATHER', { installationID, data });
};

export default {
  saveInstallations,
  saveInstallation,
  updateInstallation,
  deleteInstallation,
  saveDevice,
  updateDevice,
  deleteDevice,
  saveSchedule,
  updateSchedule,
  deleteSchedule,
  saveScene,
  updateScene,
  deleteScene,
  updateScenesOrder,
  saveWeather,
};
